import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import DatePicker from "react-datepicker";
import Select from "react-select";
import toast from "react-hot-toast";
import api from "../../api/axios";
import { formatDateForSQL } from "../../utils/formatDateForSQL";

const EditHolidayModal = ({
  holiday,
  show,
  canEdit,
  canDelete,
  onClose,
  onSaved,
  onDelete,
}) => {
  const [occasion, setOccasion] = useState("");
  const [configurationHolidays, setConfigurationHolidays] = useState([]);
  const [date, setDate] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!show) return;

    const fetchConfigurationHolidays = async () => {
      try {
        const response = await api.get("/configuration-holidays");
        const holidays = response.data.data || response.data || [];
        setConfigurationHolidays(holidays);
      } catch (error) {
        toast.error("Failed to fetch holidays list");
      }
    };

    fetchConfigurationHolidays();
  }, [show]);

  useEffect(() => {
    if (holiday) {
      setOccasion(
        holiday.title
          ? {
              value: holiday.title,
              label: holiday.title,
              occasion: holiday.title,
            }
          : null,
      );
      setDate(holiday.date ? new Date(`${holiday.date}T00:00:00`) : null);
    }
  }, [holiday]);

  const handleSave = async () => {
    if (!canEdit) return;

    if (!occasion?.value || !date) {
      toast.error("Holiday name and date are required");
      return;
    }

    try {
      setSaving(true);
      await api.put(`company-holidays/${holiday.companyHolidayId}`, {
        occasion: occasion.value,
        holiday_date: formatDateForSQL(date),
        year: date.getFullYear(),
      });
      toast.success("Holiday updated successfully");
      onSaved();
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to update holiday");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit Holiday</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="input-block mb-3">
          <label className="col-form-label">
            Holiday Name <span className="text-danger">*</span>
          </label>
          <Select
            value={occasion}
            onChange={setOccasion}
            options={configurationHolidays.map((configurationHoliday) => ({
              value: configurationHoliday.occasion,
              label: configurationHoliday.occasion,
              occasion: configurationHoliday.occasion,
            }))}
            placeholder="Select holiday..."
            isClearable
          />
        </div>
        <div className="input-block mb-3">
          <label className="col-form-label">
            Holiday Date <span className="text-danger">*</span>
          </label>
          <DatePicker
            selected={date}
            onChange={setDate}
            className="form-control datetimepicker"
            dateFormat="dd-MM-yyyy"
          />
        </div>
      </Modal.Body>
      <Modal.Footer className="justify-content-between">
        {canDelete && (
          <Button variant="danger" onClick={onDelete} disabled={saving}>
            Delete
          </Button>
        )}
        <div className="ms-auto">
          <Button variant="secondary" onClick={onClose} disabled={saving}>
            Cancel
          </Button>{" "}
          <Button
            variant="primary"
            onClick={handleSave}
            disabled={saving || !canEdit}
          >
            Save
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default EditHolidayModal;
